(function () {
  function trackReviewFunnel(step, details) {
    const payload = Object.assign({
      event: 'nt_review_funnel',
      nt_review_step: step,
      page_path: window.location.pathname
    }, details || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    window.dispatchEvent(new CustomEvent('nt:review-funnel', { detail: payload }));
  }

  function element(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function communityLikeVisitorId() {
    const storageKey = 'nt-fairing:community-like-visitor';
    try {
      let id = window.localStorage.getItem(storageKey);
      if (!id) {
        id = window.crypto && typeof window.crypto.randomUUID === 'function'
          ? window.crypto.randomUUID().replace(/-/g, '')
          : Array.from(window.crypto.getRandomValues(new Uint8Array(24)), function (byte) { return byte.toString(16).padStart(2, '0'); }).join('');
        window.localStorage.setItem(storageKey, id);
      }
      return id;
    } catch (_error) {
      return `visitor_${Date.now()}_${Math.random().toString(36).slice(2)}_${Math.random().toString(36).slice(2)}`;
    }
  }

  function communityLikesUrl(endpoint, visitorId) {
    const url = new URL(endpoint, window.location.origin);
    url.searchParams.set('visitor_id', visitorId);
    return url.toString();
  }

  function createPublishedReviewCard(review) {
    const card = element('article', 'nt-gallery-card');
    card.hidden = true;
    card.dataset.brand = review.brand || 'other';
    card.dataset.date = review.publishedAt || '';
    card.dataset.likes = '0';
    card.dataset.galleryId = `submitted-${review.id}`;
    card.id = `review-${card.dataset.galleryId}`;

    const media = element('div', 'nt-gallery-card__media');
    media.style.setProperty('--nt-review-ratio', '4 / 5');
    media.setAttribute('data-nt-gallery-carousel', '');
    (review.media || []).forEach(function (file, index) {
      const isVideo = String(file.type || '').indexOf('video/') === 0;
      const item = element(isVideo ? 'video' : 'img', `nt-gallery-card__slide${isVideo ? ' nt-gallery-card__video' : ''}`);
      item.setAttribute('data-nt-gallery-slide', String(index));
      item.hidden = index !== 0;
      if (isVideo) {
        item.controls = true;
        item.preload = 'none';
        item.dataset.ntSrc = file.url;
      } else {
        item.dataset.ntSrc = file.url;
        item.alt = `${review.product || 'NT FAIRING'} owner photo ${index + 1}`;
        item.loading = 'lazy';
        item.decoding = 'async';
      }
      media.appendChild(item);
    });
    if ((review.media || []).length > 1) {
      const previous = element('button', 'nt-gallery-card__arrow nt-gallery-card__arrow--prev', '‹');
      previous.type = 'button'; previous.setAttribute('aria-label', 'Previous owner photo'); previous.setAttribute('data-nt-gallery-prev', '');
      const next = element('button', 'nt-gallery-card__arrow nt-gallery-card__arrow--next', '›');
      next.type = 'button'; next.setAttribute('aria-label', 'Next owner photo'); next.setAttribute('data-nt-gallery-next', '');
      const dots = element('div', 'nt-gallery-card__dots');
      (review.media || []).forEach(function (_file, index) {
        const dot = element('button', index === 0 ? 'is-active' : '');
        dot.type = 'button'; dot.setAttribute('aria-label', `Show owner media ${index + 1}`); dot.setAttribute('data-nt-gallery-dot', String(index));
        dots.appendChild(dot);
      });
      const count = element('span', 'nt-gallery-card__count');
      const current = element('b', '', '1'); current.setAttribute('data-nt-gallery-current', '');
      count.append(current, document.createTextNode(`/${review.media.length}`));
      media.append(previous, next, dots, count);
    }
    card.appendChild(media);

    const copy = element('div', 'nt-gallery-card__copy');
    const meta = element('div', 'nt-gallery-card__meta');
    meta.append(element('span', '', review.product || 'NT FAIRING OWNER BUILD'), element('small', '', `${String(review.source || 'shopify').toUpperCase()} VERIFIED PURCHASE`));
    copy.append(meta, element('h3', '', review.title || 'Owner review'));
    const stars = element('div', 'nt-gallery-stars');
    stars.setAttribute('aria-label', `${review.rating || 0} out of 5 stars`);
    for (let index = 1; index <= 5; index += 1) stars.appendChild(element('span', index > Number(review.rating || 0) ? 'is-empty' : '', '★'));
    stars.appendChild(element('em', '', `${Number(review.rating || 0)}.0`));
    copy.append(stars, element('p', '', `“${review.review || ''}”`));
    const footer = element('footer');
    footer.appendChild(element('small', '', review.customer || 'Verified owner'));
    const actions = element('div', 'nt-gallery-card__actions');
    if (review.productUrl) {
      const link = element('a', 'nt-gallery-card__product-link', 'VIEW PRODUCT →');
      link.href = review.productUrl;
      link.setAttribute('aria-label', `View product for ${review.product || 'this owner build'}`);
      actions.appendChild(link);
    }
    const share = element('button', 'nt-gallery-card__share');
    share.type = 'button'; share.setAttribute('data-nt-gallery-share', ''); share.setAttribute('aria-label', `Share voting link for ${review.title || 'this owner build'}`); share.title = 'Share voting link';
    share.append(element('span', '', '↗'), element('b', '', 'SHARE'));
    actions.appendChild(share);
    const like = element('button');
    like.type = 'button'; like.setAttribute('data-nt-gallery-like', ''); like.setAttribute('aria-label', `Like ${review.title || 'this owner build'}`); like.setAttribute('aria-pressed', 'false');
    like.append(element('span', '', '♡'), element('b', '', '0'));
    actions.appendChild(like); footer.appendChild(actions); copy.appendChild(footer); card.appendChild(copy);
    return card;
  }

  async function loadPublishedReviews(root) {
    const feed = root.dataset.ntGalleryFeed;
    const grid = root.querySelector('[data-nt-gallery-grid]');
    if (!feed || !grid) return [];
    try {
      const response = await fetch(feed, { mode: 'cors', credentials: 'omit' });
      if (!response.ok) return [];
      const payload = await response.json();
      return (payload.reviews || []).reduce(function (published, review) {
        if (!review.id || root.querySelector(`[data-gallery-id="submitted-${CSS.escape(String(review.id))}"]`)) return published;
        published.push(createPublishedReviewCard(review));
        return published;
      }, []);
    } catch (_error) {
      // Existing curated reviews remain available if the live feed is temporarily unavailable.
      return [];
    }
  }

  async function setupGallery(root) {
    trackReviewFunnel('gallery_view');
    root.querySelectorAll('[data-nt-review-cta]').forEach(function (link) {
      link.addEventListener('click', function () {
        trackReviewFunnel('reward_cta_click', { nt_review_location: link.dataset.ntReviewCtaLocation || 'gallery' });
      });
    });
    let cards = Array.from(root.querySelectorAll('.nt-gallery-card'));
    const grid = root.querySelector('[data-nt-gallery-grid]');
    const brandButtons = Array.from(root.querySelectorAll('[data-nt-gallery-brand]'));
    const sortButtons = Array.from(root.querySelectorAll('[data-nt-gallery-sort]'));
    let activeBrand = 'all';
    let activeSort = 'newest';
    const pageSize = 9;
    let visibleLimit = pageSize;
    let savedLikes = [];
    let serverCounts = {};
    let manualCounts = {};
    let likesReady = false;
    const customerId = String(root.dataset.ntGalleryCustomer || '');
    const likesEndpoint = String(root.dataset.ntGalleryLikes || '');
    const likeVisitorId = communityLikeVisitorId();
    const commentsEndpoint = String(root.dataset.ntGalleryComments || '');
    const loadMoreButton = root.querySelector('[data-nt-gallery-load-more]');
    const progress = root.querySelector('[data-nt-gallery-progress]');
    const sentinel = root.querySelector('[data-nt-gallery-sentinel]');
    const findForm = root.querySelector('[data-nt-gallery-find]');
    const findInput = root.querySelector('[data-nt-gallery-find-input]');
    const findStatus = root.querySelector('[data-nt-gallery-find-status]');
    const urlTarget = new URL(window.location.href).searchParams.get('review') || (window.location.hash.indexOf('#review-') === 0 ? window.location.hash.slice(8) : '');
    let activeSearch = '';

    function hydrateSlide(slide) {
      if (!slide) return;
      if (slide.dataset.ntSrc) {
        slide.src = slide.dataset.ntSrc;
        delete slide.dataset.ntSrc;
      }
      slide.querySelectorAll('[data-nt-src]').forEach(function (source) {
        source.src = source.dataset.ntSrc;
        delete source.dataset.ntSrc;
      });
      if (slide.tagName === 'VIDEO' && slide.querySelector('source[src]')) slide.load();
    }

    function setupCard(card) {
      const slides = Array.from(card.querySelectorAll('[data-nt-gallery-slide]'));
      const dots = Array.from(card.querySelectorAll('[data-nt-gallery-dot]'));
      const current = card.querySelector('[data-nt-gallery-current]');
      const media = card.querySelector('[data-nt-gallery-carousel]');
      let index = 0;
      let startX = 0;
      if (!slides.length || !media) return;

      function show(next) {
        index = (next + slides.length) % slides.length;
        hydrateSlide(slides[index]);
        slides.forEach(function (slide, slideIndex) {
          const active = slideIndex === index;
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
        });
        dots.forEach(function (dot, dotIndex) {
          const active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
        if (current) current.textContent = String(index + 1);
      }

      const previous = card.querySelector('[data-nt-gallery-prev]');
      const next = card.querySelector('[data-nt-gallery-next]');
      if (previous) previous.addEventListener('click', function () { show(index - 1); });
      if (next) next.addEventListener('click', function () { show(index + 1); });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () { show(Number(dot.dataset.ntGalleryDot)); });
      });
      media.addEventListener('touchstart', function (event) { startX = event.touches[0].clientX; }, { passive: true });
      media.addEventListener('touchend', function (event) {
        const distance = event.changedTouches[0].clientX - startX;
        if (Math.abs(distance) > 45) show(index + (distance < 0 ? 1 : -1));
      }, { passive: true });
    }

    function manualLikesFor(card) {
      const id = String(card.dataset.galleryId || '');
      const bareId = id.replace(/^submitted-/, '');
      return Number(manualCounts[id] ?? manualCounts[bareId] ?? 0);
    }

    function likesFor(card) {
      return Number(card.dataset.likes || 0)
        + Number(serverCounts[card.dataset.galleryId] || 0)
        + manualLikesFor(card);
    }

    function render() {
      const sorted = cards.slice().sort(function (a, b) {
        return activeSort === 'liked'
          ? likesFor(b) - likesFor(a)
          : String(b.dataset.date).localeCompare(String(a.dataset.date));
      });
      const matching = sorted.filter(function (card) {
        const brandMatches = activeBrand === 'all' || card.dataset.brand === activeBrand;
        const searchMatches = !activeSearch || `${card.dataset.galleryId} ${card.textContent}`.toLowerCase().indexOf(activeSearch) > -1;
        return brandMatches && searchMatches;
      });
      sorted.forEach(function (card) {
        const visible = matching.indexOf(card) > -1 && matching.indexOf(card) < visibleLimit;
        card.hidden = !visible;
        if (visible) hydrateSlide(card.querySelector('[data-nt-gallery-slide]:not([hidden])') || card.querySelector('[data-nt-gallery-slide]'));
        grid.appendChild(card);
        const button = card.querySelector('[data-nt-gallery-like]');
        const liked = savedLikes.includes(card.dataset.galleryId);
        button.classList.toggle('is-liked', liked);
        button.setAttribute('aria-pressed', String(liked));
        button.querySelector('b').textContent = String(likesFor(card));
      });
      if (progress) progress.textContent = `Showing ${Math.min(visibleLimit, matching.length)} of ${matching.length} reviews`;
      if (loadMoreButton) loadMoreButton.hidden = visibleLimit >= matching.length;
    }

    function resetAndRender() {
      visibleLimit = pageSize;
      render();
    }

    function loadMore() {
      const matchingCount = cards.filter(function (card) {
        const brandMatches = activeBrand === 'all' || card.dataset.brand === activeBrand;
        const searchMatches = !activeSearch || `${card.dataset.galleryId} ${card.textContent}`.toLowerCase().indexOf(activeSearch) > -1;
        return brandMatches && searchMatches;
      }).length;
      if (visibleLimit >= matchingCount) return;
      visibleLimit += pageSize;
      render();
    }

    brandButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        activeBrand = button.dataset.ntGalleryBrand;
        brandButtons.forEach(function (item) { item.classList.toggle('is-active', item === button); });
        resetAndRender();
      });
    });
    sortButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        activeSort = button.dataset.ntGallerySort;
        sortButtons.forEach(function (item) { item.classList.toggle('is-active', item === button); });
        resetAndRender();
      });
    });
    function setupLike(card) {
      card.querySelector('[data-nt-gallery-like]').addEventListener('click', async function () {
        if (!likesReady || !likesEndpoint) {
          window.alert('Likes are temporarily unavailable. Please try again shortly.');
          return;
        }
        const id = card.dataset.galleryId;
        try {
          const response = await fetch(communityLikesUrl(likesEndpoint, likeVisitorId), {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ reviewId: id, visitorId: likeVisitorId })
          });
          const payload = await response.json();
          if (!response.ok) throw new Error(payload.error || 'Unable to update like');
          serverCounts[id] = Number(payload.count || 0);
          savedLikes = payload.liked ? savedLikes.concat(id).filter(function (item, index, values) { return values.indexOf(item) === index; }) : savedLikes.filter(function (item) { return item !== id; });
          render();
          window.dispatchEvent(new CustomEvent('nt:review-like-updated', { detail: payload }));
        } catch (error) {
          window.alert(error && error.message ? error.message : 'The like was not saved. Please try again.');
        }
      });
    }

    function shareUrl(card) {
      const url = new URL(window.location.href);
      url.searchParams.set('review', card.dataset.galleryId);
      url.hash = `review-${card.dataset.galleryId}`;
      return url.toString();
    }

    function setupShare(card) {
      const button = card.querySelector('[data-nt-gallery-share]');
      if (!button) return;
      button.addEventListener('click', async function () {
        const url = shareUrl(card);
        const original = button.querySelector('b').textContent;
        try {
          if (navigator.share) {
            await navigator.share({ title: 'Vote for my NT Fairing build', text: 'Please like my motorcycle build.', url: url });
          } else {
            await navigator.clipboard.writeText(url);
            button.querySelector('b').textContent = 'COPIED';
            window.setTimeout(function () { button.querySelector('b').textContent = original; }, 1800);
          }
        } catch (error) {
          if (error && error.name === 'AbortError') return;
          window.prompt('Copy this voting link:', url);
        }
      });
    }

    function commentNode(comment) {
      const item = element('div', 'nt-gallery-comment');
      const name = element('b', '', comment.customer_name || comment.customerName || 'NT RIDER');
      const body = element('span', '', comment.body || '');
      const dateValue = comment.created_at || comment.createdAt || '';
      const date = element('time', '', dateValue ? new Date(dateValue).toLocaleDateString() : '');
      if (dateValue) date.dateTime = dateValue;
      item.append(name, body, date);
      return item;
    }

    function setupComments(card) {
      if (!commentsEndpoint) return;
      const copy = card.querySelector('.nt-gallery-card__copy');
      if (!copy || copy.querySelector('[data-nt-gallery-comments]')) return;
      const details = element('details', 'nt-gallery-comments');
      details.setAttribute('data-nt-gallery-comments', '');
      const summary = element('summary', '', 'COMMENTS');
      const list = element('div', 'nt-gallery-comments__list');
      const form = element('form', 'nt-gallery-comments__form');
      const input = element('input');
      input.type = 'text';
      input.maxLength = 500;
      input.placeholder = customerId ? 'Write a comment' : 'Sign in to comment';
      input.disabled = !customerId;
      const submit = element('button', '', customerId ? 'POST' : 'SIGN IN');
      submit.type = customerId ? 'submit' : 'button';
      const status = element('p', 'nt-gallery-comments__status');
      form.append(input, submit);
      details.append(summary, list, form, status);
      copy.appendChild(details);
      let loaded = false;

      async function loadComments() {
        if (loaded) return;
        status.textContent = 'Loading comments…';
        try {
          const url = new URL(commentsEndpoint, window.location.origin);
          url.searchParams.set('reviewId', card.dataset.galleryId);
          const response = await fetch(url.toString(), { credentials: 'same-origin', headers: { Accept: 'application/json' } });
          const payload = await response.json();
          if (!response.ok) throw new Error(payload.error || 'Unable to load comments');
          list.replaceChildren();
          (payload.comments || []).forEach(function (comment) { list.appendChild(commentNode(comment)); });
          summary.textContent = `COMMENTS (${(payload.comments || []).length})`;
          status.textContent = (payload.comments || []).length ? '' : 'No comments yet.';
          loaded = true;
        } catch (_) {
          status.textContent = 'Comments are temporarily unavailable.';
        }
      }

      details.addEventListener('toggle', function () { if (details.open) loadComments(); });
      if (!customerId) {
        submit.addEventListener('click', function () { window.location.assign(root.dataset.ntGalleryLogin || '/account/login'); });
        return;
      }
      form.addEventListener('submit', async function (event) {
        event.preventDefault();
        const body = input.value.trim();
        if (!body) return;
        submit.disabled = true;
        status.textContent = 'Posting…';
        try {
          const response = await fetch(commentsEndpoint, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ reviewId: card.dataset.galleryId, body: body })
          });
          const payload = await response.json();
          if (response.status === 401) {
            window.location.assign(root.dataset.ntGalleryLogin || '/account/login');
            return;
          }
          if (!response.ok) throw new Error(payload.error || 'Unable to post comment');
          list.appendChild(commentNode(payload.comment));
          input.value = '';
          summary.textContent = `COMMENTS (${list.children.length})`;
          status.textContent = '';
          loaded = true;
        } catch (error) {
          status.textContent = error && error.message ? error.message : 'The comment was not saved.';
        } finally {
          submit.disabled = false;
        }
      });
    }

    function highlightCard(card) {
      if (!card) return;
      cards.forEach(function (item) { item.classList.remove('is-targeted'); });
      card.classList.add('is-targeted');
      card.setAttribute('tabindex', '-1');
      window.requestAnimationFrame(function () {
        card.scrollIntoView({ behavior: 'smooth', block: 'center' });
        card.focus({ preventScroll: true });
      });
    }

    function revealById(id) {
      const card = cards.find(function (item) { return item.dataset.galleryId === id; });
      if (!card) return false;
      activeBrand = 'all';
      activeSearch = '';
      activeSort = 'newest';
      brandButtons.forEach(function (button) { button.classList.toggle('is-active', button.dataset.ntGalleryBrand === 'all'); });
      sortButtons.forEach(function (button) { button.classList.toggle('is-active', button.dataset.ntGallerySort === 'newest'); });
      const sorted = cards.slice().sort(function (a, b) { return String(b.dataset.date).localeCompare(String(a.dataset.date)); });
      visibleLimit = Math.max(pageSize, sorted.indexOf(card) + 1);
      render();
      highlightCard(card);
      return true;
    }

    if (findForm && findInput) {
      findForm.addEventListener('submit', function (event) {
        event.preventDefault();
        const query = findInput.value.trim().toLowerCase();
        if (!query) {
          activeSearch = '';
          if (findStatus) findStatus.textContent = '';
          resetAndRender();
          return;
        }
        const exact = cards.find(function (card) { return card.dataset.galleryId.toLowerCase() === query.replace(/^review-/, ''); });
        if (exact) {
          activeSearch = '';
          if (findStatus) findStatus.textContent = `Found review ${exact.dataset.galleryId}`;
          revealById(exact.dataset.galleryId);
          return;
        }
        activeBrand = 'all';
        activeSearch = query;
        brandButtons.forEach(function (button) { button.classList.toggle('is-active', button.dataset.ntGalleryBrand === 'all'); });
        const matches = cards.filter(function (card) { return `${card.dataset.galleryId} ${card.textContent}`.toLowerCase().indexOf(query) > -1; });
        visibleLimit = Math.max(pageSize, matches.length);
        render();
        if (findStatus) findStatus.textContent = matches.length ? `Found ${matches.length} review${matches.length === 1 ? '' : 's'}` : 'No matching review found';
        if (matches.length) highlightCard(matches[0]);
      });
      findInput.addEventListener('search', function () {
        if (!findInput.value) {
          activeSearch = '';
          if (findStatus) findStatus.textContent = '';
          resetAndRender();
        }
      });
    }

    cards.forEach(function (card) { setupCard(card); setupLike(card); setupShare(card); setupComments(card); });
    if (loadMoreButton) loadMoreButton.addEventListener('click', loadMore);
    if (sentinel && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) loadMore();
      }, { rootMargin: '500px 0px 200px' });
      observer.observe(sentinel);
    }
    render();
    if (urlTarget) revealById(urlTarget);

    if (likesEndpoint) {
      fetch(communityLikesUrl(likesEndpoint, likeVisitorId), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (!response.ok) throw new Error('Likes unavailable');
          return response.json();
        })
        .then(function (payload) {
          savedLikes = Array.isArray(payload.liked) ? payload.liked : [];
          serverCounts = payload.customerCounts && typeof payload.customerCounts === 'object' ? payload.customerCounts : {};
          manualCounts = payload.manualCounts && typeof payload.manualCounts === 'object' ? payload.manualCounts : {};
          likesReady = true;
          render();
        })
        .catch(function () {
          savedLikes = [];
          serverCounts = {};
        });
    }

    loadPublishedReviews(root).then(function (publishedCards) {
      publishedCards.forEach(function (card) {
        cards.push(card);
        grid.appendChild(card);
        setupCard(card);
        setupLike(card);
        setupShare(card);
        setupComments(card);
      });
      render();
      if (urlTarget) {
        const found = revealById(urlTarget);
        if (!found && findStatus) findStatus.textContent = 'This review is not published yet';
      }
    });

    window.addEventListener('nt:review-like-updated', function (event) {
      const payload = event.detail || {};
      if (!payload.reviewId) return;
      serverCounts[payload.reviewId] = Number(payload.customerLikeCount || 0);
      manualCounts[payload.reviewId] = Number(payload.manualLikeCount || 0);
      savedLikes = payload.liked
        ? savedLikes.concat(payload.reviewId).filter(function (item, index, values) { return values.indexOf(item) === index; })
        : savedLikes.filter(function (item) { return item !== payload.reviewId; });
      render();
    });
  }

  function setupSupport(root) {
    const tabs = Array.from(root.querySelectorAll('[data-nt-support-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-nt-support-panel]'));

    root.querySelectorAll('.nt-faq-list details').forEach(function (item) {
      item.open = false;
    });

    function activate(id, focus) {
      tabs.forEach(function (tab) {
        const active = tab.dataset.ntSupportTab === id;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (active && focus) tab.focus();
      });
      panels.forEach(function (panel) {
        const active = panel.dataset.ntSupportPanel === id;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () { activate(tab.dataset.ntSupportTab, false); });
      tab.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const offset = event.key === 'ArrowRight' ? 1 : -1;
        const next = tabs[(index + offset + tabs.length) % tabs.length];
        activate(next.dataset.ntSupportTab, true);
      });
    });
    const hashTabs = {
      '#nt-support-panel-faq': 'faq',
      '#nt-support-panel-shipping': 'shipping',
      '#nt-support-panel-after-sales': 'after-sales',
      '#nt-support-panel-contact': 'contact',
      '#support-contact': 'contact'
    };
    if (hashTabs[window.location.hash]) activate(hashTabs[window.location.hash], false);
  }

  function renderRewardDailyLimit(value) {
    const limit = Number(value);
    if (!Number.isSafeInteger(limit) || limit < 1) return;
    document.querySelectorAll('[data-nt-reward-limit-value]').forEach(function (node) { node.textContent = String(limit); });
    document.querySelectorAll('[data-nt-reward-limit-copy]').forEach(function (node) {
      node.textContent = `${limit} submission${limit === 1 ? '' : 's'} per account each calendar day (UTC)`;
    });
  }

  function setupRewardSettings(root) {
    trackReviewFunnel('reward_page_view');
    const loginCta = root.querySelector('[data-nt-reward-login-cta]');
    if (loginCta) {
      loginCta.addEventListener('click', function () { trackReviewFunnel('login_cta_click'); });
    }
    const endpoint = root.dataset.ntRewardSettings;
    if (!endpoint) return;
    fetch(endpoint, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (payload) { if (payload) renderRewardDailyLimit(payload.dailySubmissionLimit); })
      .catch(function () { /* Keep the server-enforced default if settings cannot load. */ });
  }

  function setupRewardProgress(root) {
    const list = root.querySelector('[data-nt-reward-progress-list]');
    const refresh = root.querySelector('[data-nt-reward-progress-refresh]');
    const endpoint = root.dataset.ntRewardProgress;
    const creatorProgress = root.dataset.ntRewardProgressKind === 'creator';
    if (!list || !endpoint) return;

    function formatDate(value) {
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return '';
      return new Intl.DateTimeFormat(undefined, { year: 'numeric', month: 'short', day: 'numeric' }).format(date);
    }

    function statusLabel(status) {
      if (status === 'approved') return 'APPROVED';
      if (status === 'rejected') return 'NOT APPROVED';
      return 'PENDING REVIEW';
    }

    function creatorStatusLabel(submission) {
      if (submission.status === 'rejected') return 'NOT APPROVED';
      if (submission.status !== 'approved') return 'ORIGINAL FOOTAGE RECEIVED';
      if (submission.creator_refund_status === 'refunded') return 'CREATOR PRICE REFUNDED';
      if (submission.creator_refund_status === 'eligible') return 'REFUND READY';
      if (submission.creator_public_url) return 'POST LINK RECEIVED';
      if (submission.creator_edit_status === 'ready_to_publish') return 'READY TO POST';
      if (submission.creator_edit_status === 'editing') return 'EDITING IN PROGRESS';
      return 'IN EDITING QUEUE';
    }

    function publicPostForm(submission) {
      const form = element('form', 'nt-creator-public-post');
      const platform = document.createElement('select');
      const version = document.createElement('select');
      const url = document.createElement('input');
      const button = element('button', '', 'SUBMIT SOCIAL POST');
      platform.name = 'socialPlatform';
      platform.required = true;
      platform.setAttribute('aria-label', 'Social media platform');
      [['', 'Select platform'], ['instagram', 'Instagram'], ['tiktok', 'TikTok'], ['youtube', 'YouTube'], ['facebook', 'Facebook'], ['other', 'Other']].forEach(function (optionData) {
        const option = document.createElement('option');
        option.value = optionData[0];
        option.textContent = optionData[1];
        platform.appendChild(option);
      });
      version.name = 'postVersion';
      version.required = true;
      version.setAttribute('aria-label', 'Published video version');
      [['', 'Select video version'], ['nt_edit', 'NT FAIRING edited version'], ['self_edit', 'My own edited version']].forEach(function (optionData) {
        const option = document.createElement('option');
        option.value = optionData[0];
        option.textContent = optionData[1];
        version.appendChild(option);
      });
      url.type = 'url';
      url.name = 'publicVideoUrl';
      url.placeholder = 'Public post link';
      url.required = true;
      button.type = 'submit';
      form.append(platform, version, url, button);
      form.addEventListener('submit', async function (event) {
        event.preventDefault();
        button.disabled = true;
        button.textContent = 'SAVING...';
        try {
          const response = await fetch(endpoint, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({
              action: 'submit_public_post',
              submissionId: submission.id,
              socialPlatform: platform.value,
              postVersion: version.value,
              publicVideoUrl: url.value.trim()
            })
          });
          const payload = await response.json();
          if (!response.ok) throw new Error(payload.error || 'Unable to save the social post.');
          await load();
        } catch (caught) {
          button.disabled = false;
          button.textContent = 'SUBMIT SOCIAL POST';
          window.alert(caught instanceof Error ? caught.message : 'Unable to save the social post.');
        }
      });
      return form;
    }

    function render(submissions) {
      list.replaceChildren();
      if (!submissions.length) {
        const empty = element('p', 'nt-reward-progress__empty', creatorProgress ? 'You have not submitted an installation video yet.' : 'You have not submitted a rider build yet.');
        list.appendChild(empty);
        return;
      }
      submissions.forEach(function (submission) {
        const item = element('article', 'nt-reward-progress__item');
        const copy = element('div');
        const meta = element('div', 'nt-reward-progress__meta');
        const badge = element('span', `nt-reward-progress__status nt-reward-progress__status--${submission.status}`, creatorProgress ? creatorStatusLabel(submission) : statusLabel(submission.status));
        const time = element('time', '', formatDate(submission.created_at));
        if (submission.created_at) time.dateTime = submission.created_at;
        meta.append(badge, time);
        copy.append(meta, element('h4', '', `${submission.vehicle_brand} ${submission.vehicle_model} ${submission.model_year}`));
        copy.appendChild(element('p', '', creatorProgress ? `SKU: ${submission.sku || 'Not provided'}` : (submission.review_title || 'Rider build submission')));
        if (submission.status === 'pending') copy.appendChild(element('p', '', creatorProgress ? 'Your original installation footage is safely received and waiting for review.' : 'Your photos and review are safely received and waiting for approval.'));
        if (submission.status === 'approved' && creatorProgress && submission.creator_edit_status === 'editing_required') copy.appendChild(element('p', '', 'Approved. Your original footage is waiting for editing.'));
        if (submission.status === 'approved' && creatorProgress && submission.creator_edit_status === 'editing') copy.appendChild(element('p', '', 'NT FAIRING is editing the submitted footage. The edited version will be sent through the contact information provided with your order.'));
        if (submission.status === 'approved' && creatorProgress && submission.creator_edit_status === 'ready_to_publish') copy.appendChild(element('p', '', 'The NT FAIRING edit has been sent to you. Publish that version or your own edit on one social platform, then submit the single public post below.'));
        if (submission.status === 'approved' && creatorProgress && submission.creator_public_url) copy.appendChild(element('p', '', `${Number(submission.creator_verified_likes || 0)} genuine likes verified. The Creator Price is refunded after this single post reaches 20 genuine likes.`));
        if (submission.status === 'rejected') copy.appendChild(element('p', '', submission.rejection_reason || 'This submission did not meet the review requirements.'));

        const actions = element('div', 'nt-reward-progress__actions');
        if (submission.status === 'approved' && submission.coupon_code) {
          actions.appendChild(element('strong', '', submission.coupon_code));
          const wallet = element('a', '', 'OPEN REWARD WALLET');
          wallet.href = `/pages/reward-wallet?code=${encodeURIComponent(submission.coupon_code)}`;
          actions.appendChild(wallet);
        }
        if (submission.review_url) {
          const review = element('a', '', 'VIEW PUBLISHED REVIEW');
          review.href = submission.review_url;
          actions.appendChild(review);
        }
        if (creatorProgress && submission.creator_public_url) {
          const publicPost = element('a', '', 'VIEW SOCIAL POST');
          publicPost.href = submission.creator_public_url;
          publicPost.target = '_blank';
          publicPost.rel = 'noopener';
          actions.appendChild(publicPost);
        }
        if (creatorProgress && submission.status === 'approved' && submission.creator_edit_status === 'ready_to_publish' && !submission.creator_public_url) {
          actions.appendChild(publicPostForm(submission));
        }
        item.append(copy, actions);
        list.appendChild(item);
      });
    }

    async function load() {
      if (refresh) refresh.disabled = true;
      try {
        const response = await fetch(endpoint, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
        const payload = await response.json();
        if (!response.ok) throw new Error(payload.error || 'Unable to load submissions.');
        render(Array.isArray(payload.submissions) ? payload.submissions : []);
      } catch (caught) {
        list.replaceChildren(element('p', 'nt-reward-progress__error', caught instanceof Error ? caught.message : 'Unable to load submissions.'));
      } finally {
        if (refresh) refresh.disabled = false;
      }
    }

    if (refresh) refresh.addEventListener('click', load);
    window.addEventListener('nt:reward-submitted', load);
    load();
  }

  function setupRewardForm(form) {
    const success = form.querySelector('[data-nt-reward-success]');
    const error = form.querySelector('[data-nt-reward-error]');
    const submit = form.querySelector('[type="submit"]');
    const fileInput = form.querySelector('input[type="file"]');
    const fileList = form.querySelector('[data-nt-reward-file-list]');
    const titleInput = form.querySelector('[data-nt-reward-title]');
    const draftKey = `ntRewardDraft:${window.location.pathname}`;
    const draftDbName = 'ntFairingDrafts';
    const draftStoreName = 'rewardFiles';
    let saveTimer;
    let selectedFiles = [];
    const creatorVideoForm = form.hasAttribute('data-nt-creator-video-form');

    function updateAutomaticTitle() {
      if (!titleInput) return;
      const brand = form.elements.vehicleBrand ? String(form.elements.vehicleBrand.value || '').trim() : '';
      const model = form.elements.vehicleModel ? String(form.elements.vehicleModel.value || '').trim() : '';
      titleInput.value = [brand, model, creatorVideoForm ? 'installation video' : 'owner review'].filter(Boolean).join(' ');
    }

    function fileKey(file) {
      return [file.name, file.size, file.lastModified].join(':');
    }

    function formatFileSize(size) {
      if (size < 1024 * 1024) return `${Math.max(1, Math.round(size / 1024))} KB`;
      return `${(size / (1024 * 1024)).toFixed(1)} MB`;
    }

    function renderSelectedFiles() {
      if (!fileList) return;
      fileList.replaceChildren();
      selectedFiles.forEach(function (file, index) {
        const row = document.createElement('div');
        const label = document.createElement('span');
        const remove = document.createElement('button');
        row.className = 'nt-reward-file';
        label.textContent = `${file.name} · ${formatFileSize(file.size)}`;
        remove.type = 'button';
        remove.textContent = 'REMOVE';
        remove.setAttribute('aria-label', `Remove ${file.name}`);
        remove.addEventListener('click', function () {
          selectedFiles.splice(index, 1);
          syncFileInput(true);
        });
        row.append(label, remove);
        fileList.appendChild(row);
      });
    }

    function syncFileInput(shouldSave) {
      if (!fileInput || typeof window.DataTransfer !== 'function') {
        renderSelectedFiles();
        return;
      }
      const transfer = new window.DataTransfer();
      selectedFiles.forEach(function (file) { transfer.items.add(file); });
      fileInput.files = transfer.files;
      renderSelectedFiles();
      if (shouldSave) saveFileDraft();
    }

    function openDraftDatabase() {
      if (!('indexedDB' in window)) return Promise.resolve(null);
      return new Promise(function (resolve) {
        const request = window.indexedDB.open(draftDbName, 1);
        request.onupgradeneeded = function () {
          const database = request.result;
          if (!database.objectStoreNames.contains(draftStoreName)) database.createObjectStore(draftStoreName);
        };
        request.onsuccess = function () { resolve(request.result); };
        request.onerror = function () { resolve(null); };
      });
    }

    function saveFieldDraft() {
      const fields = {};
      Array.from(form.elements).forEach(function (field) {
        if (!field.name || field.type === 'file' || field.type === 'submit' || field.type === 'button') return;
        if (field.type === 'checkbox' || field.type === 'radio') {
          fields[field.name] = { checked: field.checked, value: field.value };
          return;
        }
        fields[field.name] = { value: field.value };
      });
      try {
        window.sessionStorage.setItem(draftKey, JSON.stringify(fields));
      } catch (caught) {
        // Storage can be unavailable in private browsing; the form still remains usable.
      }
    }

    async function saveFileDraft() {
      if (!fileInput) return;
      const database = await openDraftDatabase();
      if (!database) return;
      const files = selectedFiles.map(function (file) {
        return { blob: file, name: file.name, type: file.type, lastModified: file.lastModified };
      });
      await new Promise(function (resolve) {
        const transaction = database.transaction(draftStoreName, 'readwrite');
        transaction.objectStore(draftStoreName).put(files, draftKey);
        transaction.oncomplete = resolve;
        transaction.onerror = resolve;
        transaction.onabort = resolve;
      });
      database.close();
    }

    async function saveDraft() {
      saveFieldDraft();
      await saveFileDraft();
    }

    function restoreFieldDraft() {
      let fields;
      try {
        fields = JSON.parse(window.sessionStorage.getItem(draftKey) || 'null');
      } catch (caught) {
        fields = null;
      }
      if (!fields) return;
      Array.from(form.elements).forEach(function (field) {
        const draft = field.name ? fields[field.name] : null;
        if (!draft || field.type === 'file' || field.type === 'submit' || field.type === 'button') return;
        if (field.type === 'checkbox' || field.type === 'radio') {
          field.checked = Boolean(draft.checked);
        } else {
          field.value = draft.value || '';
        }
      });
    }

    async function restoreFileDraft() {
      if (!fileInput || typeof window.DataTransfer !== 'function') return;
      const database = await openDraftDatabase();
      if (!database) return;
      const records = await new Promise(function (resolve) {
        const transaction = database.transaction(draftStoreName, 'readonly');
        const request = transaction.objectStore(draftStoreName).get(draftKey);
        request.onsuccess = function () { resolve(request.result || []); };
        request.onerror = function () { resolve([]); };
      });
      database.close();
      if (!records.length) return;
      try {
        selectedFiles = records.map(function (record) {
          return new File([record.blob], record.name, {
            type: record.type,
            lastModified: record.lastModified
          });
        });
        syncFileInput(false);
      } catch (caught) {
        // Some older browsers do not allow restoring a file input programmatically.
      }
    }

    async function clearDraft() {
      try { window.sessionStorage.removeItem(draftKey); } catch (caught) { /* no-op */ }
      const database = await openDraftDatabase();
      if (!database) return;
      await new Promise(function (resolve) {
        const transaction = database.transaction(draftStoreName, 'readwrite');
        transaction.objectStore(draftStoreName).delete(draftKey);
        transaction.oncomplete = resolve;
        transaction.onerror = resolve;
        transaction.onabort = resolve;
      });
      database.close();
    }

    restoreFieldDraft();
    restoreFileDraft();
    form.addEventListener('input', function () {
      window.clearTimeout(saveTimer);
      saveTimer = window.setTimeout(saveFieldDraft, 150);
    });
    form.addEventListener('change', function (event) {
      saveFieldDraft();
      if (event.target === fileInput) {
        const known = new Set(selectedFiles.map(fileKey));
        Array.from(fileInput.files || []).forEach(function (file) {
          if (!known.has(fileKey(file))) selectedFiles.push(file);
        });
        if (creatorVideoForm && selectedFiles.length > 8) selectedFiles = selectedFiles.slice(0, 8);
        syncFileInput(true);
        if (selectedFiles.length) trackReviewFunnel('media_selected', { nt_review_file_count: selectedFiles.length });
      }
    });
    window.addEventListener('pagehide', saveFieldDraft);

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      error.hidden = true;
      success.hidden = true;
      submit.disabled = true;
        submit.textContent = 'UPLOADING...';
      try {
        updateAutomaticTitle();
        if (creatorVideoForm && !selectedFiles.length && !String(form.elements.sourceFootageUrl?.value || '').trim()) {
          throw new Error('Upload the original installation footage or provide an accessible footage link.');
        }
        trackReviewFunnel('submit_started', { nt_review_file_count: selectedFiles.length });
        await saveDraft();
        const response = await fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: { Accept: 'application/json' } });
        const responseText = await response.text();
        let payload = {};
        try {
          payload = responseText ? JSON.parse(responseText) : {};
        } catch (caught) {
          payload = {};
        }
        if (response.status === 401) {
          trackReviewFunnel('login_required');
          window.location.assign(form.dataset.ntRewardLogin || `/account/login?return_url=${encodeURIComponent(`${window.location.pathname}#nt-review-reward-form`)}`);
          return;
        }
        if (!response.ok) {
          const serverMessage = typeof payload.error === 'string' ? payload.error : '';
          const exposesInternalError = /D1_ERROR|SQLITE_|constraint failed|review_submissions\.|review_media\./i.test(serverMessage);
          const fallbackMessage = response.status === 409
            ? (creatorVideoForm ? 'This Creator Kit installation video has already been submitted.' : 'A rider build for this motorcycle has already been submitted from your account. You can still submit a different motorcycle.')
            : (creatorVideoForm ? 'We could not submit your installation video. Please try again.' : 'We could not submit your rider build. Please try again.');
          throw new Error(serverMessage && !exposesInternalError ? serverMessage : fallbackMessage);
        }
        await clearDraft();
        selectedFiles = [];
        syncFileInput(false);
        if (payload.statusUrl) {
          const paragraph = document.createElement('p');
          const link = document.createElement('a');
          link.href = String(payload.statusUrl);
          link.rel = 'noreferrer';
          link.textContent = 'CHECK REWARD STATUS';
          paragraph.appendChild(link);
          success.appendChild(paragraph);
        }
        success.hidden = false;
        trackReviewFunnel('submit_success');
        form.querySelectorAll('fieldset, .nt-reward-consent, .nt-reward-submit').forEach(function (item) { item.hidden = true; });
        window.dispatchEvent(new CustomEvent('nt:reward-submitted'));
        success.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (caught) {
        trackReviewFunnel('submit_error');
        error.textContent = caught instanceof Error ? caught.message : 'Submission failed.';
        error.hidden = false;
        error.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } finally {
        submit.disabled = false;
        submit.textContent = creatorVideoForm ? 'SUBMIT INSTALLATION VIDEO' : 'SUBMIT FOR REVIEW';
      }
    });
  }

  document.querySelectorAll('[data-nt-gallery-page]').forEach(function (root) { setupGallery(root); });
  document.querySelectorAll('[data-nt-reward-settings]').forEach(setupRewardSettings);
  document.querySelectorAll('[data-nt-reward-progress]').forEach(setupRewardProgress);
  document.querySelectorAll('[data-nt-reward-form]').forEach(setupRewardForm);
  document.querySelectorAll('[data-nt-support-page]').forEach(setupSupport);
}());
